import type { Room } from "@/lib/gql/__generated__/graphql";

import { useDnD } from "@/hooks/use-dnd/use-dnd";

import { RoomListTable } from "./_components";
import { useRoomList } from "./_hooks/use-room-list/use-room-list";
import { useSortRoomList } from "./_hooks/use-sort-room-list/use-sort-room-list";

type Props = {
	hotelID: string;
};

export const RoomList = ({ hotelID }: Props) => {
	const { rooms, dummies, handleRoomDeleteItems, inUseBasic } = useRoomList({ hotelID });

	const { dndItemList, onCancelDnD } = useDnD<Room>(rooms);

	const { onSaveSort } = useSortRoomList({ hotelID, dndItemList });

	return (
		<RoomListTable
			hotelID={hotelID}
			onSaveSort={onSaveSort}
			onCancelSort={onCancelDnD}
			dndItemList={dndItemList}
			dummyRooms={dummies}
			handleRoomDelete={handleRoomDeleteItems.handleRoomDelete}
			inUseBasic={inUseBasic}
		/>
	);
};

RoomList.displayName = "RoomList";
